<div class="ui-back-button-wrapper">
  <div class="container position-relative ui-back-button-container">
    <div class="ui-back-button-content">
      <ui-back-button (click)="onClick.emit()"></ui-back-button>
      <ng-content></ng-content>
    </div>

    <div class="mobile-extra-action-select-wrap d-md-none">
      <ng-content select=".mobile-extra-action-select"></ng-content>
    </div>
  </div>
</div>
